import React from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
/**
 * MFPlaceOrderOrderDetailsColumn
 *
 * This component is used on Place order screen to display order details column
 *
 * @param {any} orderDetails - order details
 * @param {any} schemeDetails - scheme details
 * @param {any} clientDetails - client details
 * @param {any} placeOrderId - Unique identifier for each item on the place order table
 * @param {Function} callbackHandleViewAndModifyClick - call back function to view/ modify and set order details
 * @returns {}
 */
var MFPlaceOrderOrderDetailsColumn = function (props) {
    return props.orderDetails ? (React.createElement("div", { className: "d-flex flex-column justify-content-start align-items-lg-start gap-1 order-detail-container" },
        React.createElement("div", { className: "d-flex flex-row align-items-center gap-1" },
            React.createElement("label", { className: "DMSanN_15_400 txt-grey-shade1" }, props.orderDetails.trxType),
            props.orderDetails.frequency && (React.createElement(React.Fragment, null,
                React.createElement("i", { className: "edel-icon-round-circle" }),
                React.createElement("label", { className: "DMSanN_15_400 txt-grey-shade1" }, props.orderDetails.frequency))),
            props.orderDetails.amount && (React.createElement(React.Fragment, null,
                React.createElement("i", { className: "edel-icon-round-circle" }),
                React.createElement("label", { className: "DMSanN_15_400 txt-grey-shade1" }, "\u20B9".concat(props.orderDetails.amount))))),
        React.createElement(EdButton, { className: " DMSanN_15_400 view-modify-btn", btnTyp: "text-only", value: "View & modify", onClick: function () {
                return props.callbackHandleViewAndModifyClick(props.schemeDetails, props.clientDetails);
            } }))) : (React.createElement("button", { className: "d-flex align-items-center txt-han-blue gap-1 border-0 bg-transparent set-up-btn ".concat(!(Boolean(props.schemeDetails) && Boolean(props.clientDetails))
            ? "btn-disabled"
            : ""), onClick: function () {
            return props.callbackHandleViewAndModifyClick(props.schemeDetails, props.clientDetails, props.placeOrderId);
        }, disabled: !(Boolean(props.schemeDetails) && Boolean(props.clientDetails)) },
        React.createElement("i", { className: "edel-icon-settings cursor-pointer" }),
        React.createElement("label", { className: "DMSans_13_400 cursor-pointer" }, "Setup Order")));
};
export default MFPlaceOrderOrderDetailsColumn;
